import { _ as _defineProperty } from '../../defineProperty-18999f8e.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function createLayers(layerProvider, layers, inToId) {
  var acc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var layersSerializable = layers.map(function (layerItem) {
    return layerProvider.createOrUpdateLayer(_objectSpread(_objectSpread({}, layerItem.data), {}, {
      type: layerItem.type
    })).layer.toJSON();
  });
  layersSerializable.length && acc.push({
    layerId: inToId,
    layers: layersSerializable
  });
  layersSerializable.forEach(function (_ref, index) {
    var id = _ref.id;
    var _layers$index$depende = layers[index].dependencies,
        dependencies = _layers$index$depende === void 0 ? [] : _layers$index$depende;
    createLayers(layerProvider, dependencies, id, acc);
  });
  return acc;
}

export { createLayers as default };
